import { is_elementor_edit, get_cookie } from 'js/utils';

export default function init_sticky_footer_cta(){

    let container = document.querySelector('.sticky_footer_cta');
    if( !container ) return;

    if( is_elementor_edit() ) {
        import('./sticky_footer_cta.scss');
        return;
    }
    
    if( get_cookie('footer_sticky_cta_close') ) {
        container.remove();
        return;
    }

    import('./sticky_footer_cta.scss');
    import('./sticky_footer_cta');
}